import * as types from "../actions/types";

const initialState = {
  loading: false
};

export default function directoryExtraCurEducation(state = initialState, action) {
  switch (action.type) {

    case types.GET_SUBJECTS_EXTRA_CUR_EDU_LIST:
      return {
        ...state,
        extraCurEduList: action.payload
      };
    case types.SET_BASIC_EDUCATION_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    default:
      return state;
  }
}